var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCenterAlignIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C12.4142 1.5 12.75 1.83579 12.75 2.25V6H18.25C18.9404 6 19.5 6.50368 19.5 7.125V9.375C19.5 9.99632 18.9404 10.5 18.25 10.5H12.75V13.5H19.5C20.3284 13.5 21 14.0037 21 14.625V16.875C21 17.4963 20.3284 18 19.5 18H12.75V21.75C12.75 22.1642 12.4142 22.5 12 22.5C11.5858 22.5 11.25 22.1642 11.25 21.75V18H4.5C3.67157 18 3 17.4963 3 16.875V14.625C3 14.0037 3.67157 13.5 4.5 13.5H11.25V10.5H5.75C5.05964 10.5 4.5 9.99632 4.5 9.375V7.125C4.5 6.50368 5.05964 6 5.75 6H11.25V2.25C11.25 1.83579 11.5858 1.5 12 1.5Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterAlignIcon);
export default __webpack_public_path__ + "static/media/center-align-icon.44e577c734febbb89d23754a5ab5be5a.svg";
export { ForwardRef as ReactComponent };